import { Property } from "../../../gen/witbooking/backoffice/property/v1/establishment_api_pb";
import { Image } from "../../shared/widgets/ImageManager";

export const DEFAULT_TIME_ZONE = "Europe/Madrid";

export interface PropertyEntity extends Omit<Property.AsObject, "location" | "multimediaList"> {
  locationSection?: string;
  contactSection?: string;
  country: string;
  city: string;
  address: string;
  zipCode: string;
  searchCoordinates?: {
    latitude: number;
    longitude: number;
    timeZone: string;
  };
  latitude: number;
  longitude: number;
  timeZone: string;
  multimediaList: Image[];
}
